import { Box, HStack, Icon, Link, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import { BsCheckBox, BsSquare } from 'react-icons/bs'
import { AlpsAcatDetailV2WebDto } from '../../../../api/types'
import { formatDateAndTime } from '../../../../utils/dateUtil'
import RecommendedActionModal from './RecommendedActionModal'
import {
  Definition,
  DefinitionList,
  DefinitionListItem,
  DefinitionTerm,
  DefinitionValue,
} from '@apex/component-library'
import {
  getAlpsState,
  getCorrespondentName,
  getDirectionMessage,
  getNsccState,
  getRecommendedAction,
  getRejectReason,
  getTransferTypeMessage,
} from './messages'

export interface TransferDetailsProps {
  transferDetail: AlpsAcatDetailV2WebDto
}

const TransferDetails = ({ transferDetail }: TransferDetailsProps) => {
  return (
    <Box>
      <Box bg="gray.600" color="white" p={3}>
        <Text fontWeight="bold">Transfer Details</Text>
      </Box>
      {/* TODO: Use heading toolbar component */}
      <Box bg="apex.white">
        <Stack
          direction={{ base: 'column', md: 'row' }}
          spacing={0}
          borderBottomWidth={1}
          borderBottomColor={'apex.silver'}
        >
          <Box w={'100%'} className="transfer-details-definition-list">
            <DefinitionList>
              <Definition
                term={'Control Number'}
                definition={`${transferDetail.acatsControlNumber}` || '—'}
              />
              <Definition
                term={'Created'}
                definition={
                  (transferDetail.created &&
                    formatDateAndTime(transferDetail.created)) ||
                  '—'
                }
              />
              <Definition
                term={'Transfer Type'}
                definition={
                  getTransferTypeMessage(transferDetail.transferType) || '—'
                }
              />
              <Definition
                term={'Direction'}
                definition={
                  getDirectionMessage(transferDetail.direction) || '—'
                }
              />
              <Definition
                term={'Correspondent'}
                definition={getCorrespondentName(transferDetail) || '—'}
              />
              <Definition
                term={'Memo'}
                definition={`${transferDetail.status.alpsActionReason} ${transferDetail.status.notes}`}
              />
              <Definition
                term={'Public Key'}
                definition={transferDetail.anonymousKey}
              />
              <Box p={1}>
                <Link
                  href="#audit-trail"
                  color="apex.link"
                  fontWeight={'semibold'}
                >
                  View Audit Trail
                </Link>
              </Box>
            </DefinitionList>
          </Box>
          <Box w={'100%'}>
            <DefinitionList>
              <Definition
                term={'NSCC State'}
                definition={
                  getNsccState(transferDetail.status?.nsccState) || '—'
                }
              />
              <Definition
                term={'Next Action'}
                definition={
                  getRecommendedAction(transferDetail.status?.action) || '—'
                }
              />
              <Definition
                term={'ALPS State'}
                definition={getAlpsState(transferDetail.status?.state) || '—'}
              />
              <Definition
                term={'Reject Reason'}
                definition={
                  getRejectReason(transferDetail.status?.rejectReason) || '—'
                }
              />
              <Definition
                term={'Comment'}
                definition={transferDetail.caseStates?.[0]?.comment || '—'}
              />
              <DefinitionListItem>
                <DefinitionTerm>Recommended Action</DefinitionTerm>
                <DefinitionValue>
                  <Box>
                    <HStack>
                      <Text>
                        {getRecommendedAction(
                          transferDetail.status.alpsRecommendedAction
                        ) || '—'}
                      </Text>
                      {transferDetail.caseStates?.length > 0 && (
                        <RecommendedActionModal
                          caseStates={transferDetail.caseStates}
                        />
                      )}
                    </HStack>
                  </Box>
                </DefinitionValue>
              </DefinitionListItem>
              <Definition
                term={'Override Action'}
                definition={
                  getRecommendedAction(
                    transferDetail.caseStates?.[0]?.override
                  ) || '—'
                }
              />
              <Box p={1}>
                <Stack direction="row" spacing={12}>
                  <Box>
                    <Text
                      aria-label={
                        transferDetail.status.isScheduled
                          ? 'Scheduled'
                          : 'Not Scheduled'
                      }
                    >
                      <Icon
                        as={
                          transferDetail.status.isScheduled
                            ? BsCheckBox
                            : BsSquare
                        }
                        mr={1}
                      />{' '}
                      Scheduled
                    </Text>
                  </Box>
                  <Box>
                    <Text
                      aria-label={
                        transferDetail.status.isSubmitted
                          ? 'Submitted'
                          : 'Not Submitted'
                      }
                    >
                      <Icon
                        as={
                          transferDetail.status.isSubmitted
                            ? BsCheckBox
                            : BsSquare
                        }
                        mr={1}
                      />{' '}
                      Submitted
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </DefinitionList>
          </Box>
        </Stack>
      </Box>
    </Box>
  )
}

export default TransferDetails
